var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAndroidColor = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M640 320C640 497 497 640 320 640C143 640 0 497 0 320C0 143 143 0 320 0C497 0 640 143 640 320Z",
    id: "a12CB593P4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 246C152 246 140 258 140 272C140 282.8 140 369.2 140 380C140 394 152 406 166 406C181 406 192 394 192 380C192 369.1 192 281.9 192 271C193 257 181 246 166 246M378 148C388.8 128.2 394.8 117.2 396 115C397 113 396 111 395 110C393 109 391 110 390 111C388.1 114.3 372.9 140.7 371 144C355 137 338 133 320 133C302 133 284 137 269 144C267.1 140.8 251.9 115.2 250 112C249 110 247 110 245 110C243 111 243 113 244 115C245.8 118.3 260.2 144.7 262 148C226 166 202 201 202 241C225.6 241 414.4 241 438 241C438 202 414 167 378 148M266 199C261 199 256 195 256 189C256 184 260 179 266 179C271 179 276 183 276 189C276 195 272 199 266 199M374 199C369 199 364 195 364 189C364 184 368 179 374 179C379 179 384 183 384 189C384 195 379 199 374 199M203 419C203 434 216 447 231 447C232.27 447 238.6 447 250 447C250 481.2 250 500.2 250 504C250 518 262 530 276 530C291 530 302 518 302 504C302 500.2 302 481.2 302 447L337 447C337 481.2 337 500.2 337 504C337 518 349 530 363 530C378 530 389 518 389 504C389 500.2 389 481.2 389 447C400.4 447 406.73 447 408 447C423 447 436 435 436 419C436 407.8 436 351.8 436 251L203 251C203 351.8 203 407.8 203 419ZM474 246C460 246 448 258 448 272C448 282.9 448 370.1 448 381C448 395 460 407 474 407C488 407 500 395 500 381C500 373.73 500 337.4 500 272C492 254.67 483.33 246 474 246Z",
    id: "b3EgspwOne"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a12CB593P4",
    opacity: 1,
    fill: "#68AE0A",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a12CB593P4",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3EgspwOne",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3EgspwOne",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAndroidColor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/android_color.3332e170fb6f9cecf6538b188f9342eb.svg";